/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime.js';
import { AirlineRefundMethodFromJSON, AirlineRefundMethodToJSON, } from './AirlineRefundMethod.js';
import { ModificationTimeFromJSON, ModificationTimeToJSON, } from './ModificationTime.js';
import { ModificationTypeFromJSON, ModificationTypeToJSON, } from './ModificationType.js';
/**
 * Check if a given object implements the FareRule interface.
 */
export function instanceOfFareRule(value) {
    let isInstance = true;
    isInstance = isInstance && "modificationType" in value;
    isInstance = isInstance && "modificationTime" in value;
    isInstance = isInstance && "allowed" in value;
    return isInstance;
}
export function FareRuleFromJSON(json) {
    return FareRuleFromJSONTyped(json, false);
}
export function FareRuleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'modificationType': ModificationTypeFromJSON(json['modification_type']),
        'modificationTime': ModificationTimeFromJSON(json['modification_time']),
        'allowed': json['allowed'],
        'fee': !exists(json, 'fee') ? undefined : json['fee'],
        'percentage': !exists(json, 'percentage') ? undefined : json['percentage'],
        'refundMethod': !exists(json, 'refund_method') ? undefined : AirlineRefundMethodFromJSON(json['refund_method']),
    };
}
export function FareRuleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'modification_type': ModificationTypeToJSON(value.modificationType),
        'modification_time': ModificationTimeToJSON(value.modificationTime),
        'allowed': value.allowed,
        'fee': value.fee,
        'percentage': value.percentage,
        'refund_method': AirlineRefundMethodToJSON(value.refundMethod),
    };
}
